import { render, staticRenderFns } from "./YieldPredictionReportDetails.vue?vue&type=template&id=2f058d7b&scoped=true"
import script from "./YieldPredictionReportDetails.vue?vue&type=script&lang=js"
export * from "./YieldPredictionReportDetails.vue?vue&type=script&lang=js"
import style0 from "./YieldPredictionReportDetails.vue?vue&type=style&index=0&id=2f058d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f058d7b",
  null
  
)

export default component.exports